import React from 'react'
import { useLocation, useHistory } from 'react-router-dom'

import { Container, IconWrapper } from './style'
import LogoIcon from '../icons/LogoIcon'
import { banners } from '../../components/constants/banners'

import { setEditSetup, getDepartmentName, getBannerImage } from '../../services/auth'

export default function Header(props) {
  const { pathname } = useLocation()
  let history = useHistory()
  const [backImage, setBackImage] = React.useState('')
  React.useEffect(() => {
    banners.filter((i) => i.value === getBannerImage() ? setBackImage(i.image) : null)
  },[])
  const handleRedirect = () => {
    // setEditSetup('true')

    history.push('/home')
  }

  const departamentTitle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: `url(${backImage})`,
    backgroundSize: 'cover',
    width: '100%',
    height: 300,
  }

  const backgroundColor = {
    height: 300,
    width: '100%',
    position: 'absolute',
    backgroundColor: 'rgba(0, 0, 0, 0.59)'
  }

  const DepatamentName = () => (
    <div style={departamentTitle}>
      <div style={backgroundColor} />
      <p>{getDepartmentName()}</p>
    </div>
  )

  return (
    <Container>
      <IconWrapper>
        <LogoIcon onClick={handleRedirect} />
      </IconWrapper>

      {pathname === '/categories' && <DepatamentName />}
    </Container>
  )
}
